import styled from 'styled-components';
import { FaPinterestP } from 'react-icons/fa';
var PinterestIcon = styled(FaPinterestP).attrs({
  color: "#f7f7f7",
  size: "calc(50%)"
}).withConfig({
  displayName: "PinterestShareButtonstyles__PinterestIcon",
  componentId: "pantheon__sc-18bkypy-0"
})([""]);
export { PinterestIcon };